export default {
  name: '(P) Variants',
  slug: 'p-variants',
  class: 'gf_variants',
  wrap: 'gf_variants-wrapper',
};
